export default function SendMessageIcon({
  className = "",
}: {
  className?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.8151 12.197L5.28308 13.453C5.19649 13.4674 5.11522 13.5044 5.04746 13.5602C4.97971 13.6161 4.92784 13.6887 4.89708 13.771L2.30008 20.728C2.05208 21.368 2.72108 21.978 3.33508 21.671L21.3351 12.671C21.4598 12.6087 21.5646 12.513 21.6379 12.3944C21.7112 12.2759 21.75 12.1393 21.75 12C21.75 11.8606 21.7112 11.724 21.6379 11.6055C21.5646 11.487 21.4598 11.3912 21.3351 11.329L3.33508 2.32896C2.72108 2.02196 2.05208 2.63296 2.30008 3.27196L4.89808 10.229C4.92869 10.3114 4.9805 10.3843 5.04827 10.4403C5.11604 10.4963 5.19737 10.5334 5.28408 10.548L12.8161 11.803C12.8624 11.8111 12.9044 11.8353 12.9347 11.8713C12.965 11.9074 12.9816 11.9529 12.9816 12C12.9816 12.047 12.965 12.0926 12.9347 12.1286C12.9044 12.1646 12.8624 12.1888 12.8161 12.197H12.8151Z"
        fill="#1E293B"
      />
    </svg>
  );
}
